import React from "react";
import { useTranslation } from "react-i18next";

import HeroSection from "../../components/HeroSection/HeroSection";
import Footer from "../../components/Footer/Footer";

// Importing Images
import RestaurantInterior2 from "../../assets/images/restaurant-interior2.jpg";
import ReserveForm from "../../components/ReserveForm/ReserveForm";

const ReservarPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeroSection
        title={t("Pedido de Reserva")}
        subtitle=""
        backgroundImage={RestaurantInterior2}
        variant="default"
      />
      <ReserveForm />

      <Footer />
    </>
  );
};

export default ReservarPage;
